import axios from "axios"
import { ACTIVE_ETA_PWA_URL, ACTIVE_SERVICE_URL } from "../utils/environment"

export const NEWS_AND_PROMO_ACTION_GET_DATA = async (callback, errorCallback) => {
    axios.get(`${ACTIVE_SERVICE_URL}/newsAndPromo/${ACTIVE_ETA_PWA_URL}`)
        .then(res => callback(res))
        .catch(err => errorCallback(err))
}